import { initializeFaro, getWebInstrumentations, FetchTransport, LogLevel } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

import { getFaroConfig, validateFaroConfig } from './config';
import { createFaroBeforeSend } from './piiRedaction';

// initFaro() is now invoked from a feature-flag-gated effect (see pages/_app.tsx)
// rather than once at module load, so guard against it running more than once
// (e.g. React effect re-runs, Strict Mode double-invocation).
let hasInitialized = false;

export function initFaro() {
  if (typeof window === 'undefined' || hasInitialized) {
    return;
  }

  const config = getFaroConfig();

  if (!validateFaroConfig(config)) {
    // eslint-disable-next-line no-console
    console.warn('Grafana Faro URL not configured or is a placeholder. Skipping Faro initialization.');
    return;
  }

  try {
    initializeFaro({
      app: {
        name: config.appName,
        version: config.version,
        environment: config.environment,
      },
      instrumentations: [...getWebInstrumentations({ captureConsole: true }), new TracingInstrumentation()],
      consoleInstrumentation: {
        disabledLevels: [LogLevel.DEBUG, LogLevel.TRACE, LogLevel.LOG, LogLevel.INFO],
      },
      transports: [new FetchTransport({ url: config.collectorUrl, bufferSize: 60 })],
      batching: { sendTimeout: 2000, itemLimit: 100 },
      beforeSend: createFaroBeforeSend(),
    });
    hasInitialized = true;
    // eslint-disable-next-line no-console
    console.log('Grafana Faro initialized successfully.');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialize Grafana Faro:', error);
  }
}
